import { render, staticRenderFns } from "./ProjectCompletedNotification.vue?vue&type=template&id=69366c57&scoped=true&"
import script from "./ProjectCompletedNotification.vue?vue&type=script&lang=js&"
export * from "./ProjectCompletedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69366c57",
  null
  
)

export default component.exports